import { AfterViewInit, Component, inject, signal } from '@angular/core';
import { TimetableService } from '../../timetable.service';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-timetable-year-selection',
  templateUrl: './timetable-year-selection.component.html',
  standalone: false,
})
export class TimetableYearSelectionComponent implements AfterViewInit {
  public years = signal<number[]>([]);
  public readonly timetableService = inject(TimetableService);

  ngAfterViewInit(): void {
    this.timetableService.yearsLoaded$
      .pipe(
        take(1),
        filter((years) => years !== null),
      )
      .subscribe((allYears) => {
        this.years.set(allYears);
        if (!this.timetableService.selectedYear) {
          this.timetableService.selectedYear = this.years()[this.years().length - 1];
          this.timetableService.yearChanged$.next(this.timetableService.selectedYear);
        }
      });
  }

  yearChanged(selectedValue: number) {
    this.timetableService.selectedYear = selectedValue;
    this.timetableService.yearChanged$.next(selectedValue);
  }
}
